export enum SessionStorageConstants {
    USER = 'USER',
    MULTIPLE_USER = 'MULTIPLE_USER',
}